<template>
    <div class="groupitem-admin">
         <PageTitle icon="fa fa-cubes" main="Grupo de Item" sub="Acesso ao cadastro do item" />
         <b-form class="mt-2" v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="groupitem-id" type="hidden" v-model="groupitem.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Nome:" label-for="groupitemname">
                        <b-form-input 
                            id="groupitemname" 
                            ref="focusadd"
                            type="text" 
                            v-model="groupitem.name" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Nome do Grupo..." />
                    </b-form-group>
                </b-col>    
                <b-col md="3" sm="12">    
                     <b-form-group label="Código:" label-for="groupitem-internal_code_group_item">
                        <b-form-input 
                            id="groupitem-internal_code_group_item" 
                            type="text"
                            v-model="groupitem.internal_code_group_item" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código..." />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="groupitem.blocked" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-blocked"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>  
             </b-row>
             <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="groupitem.synthetic" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-synthetic"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-synthetic">
                                Sintético?
                            </label>
                        </div>
                    </div>
                </b-col> 
                <b-col md="3" sm="12">
                    <div class="form-group" v-show="this.groupitem.synthetic == 1 ? false: true">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="groupitem.item_sale" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-item_sale"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-item_sale">
                                Grupo de Venda?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <div class="form-group"  v-show="this.groupitem.synthetic == 1 ? false: true">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="groupitem.item_purchase" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-item_purchase"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-item_purchase">
                                Grupo de Compra?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <div class="form-group" v-show="this.groupitem.synthetic == 1 ? false: true">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="groupitem.item_service" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-item_service"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-item_service">
                                Grupo de Serviço?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row v-show="this.groupitem.synthetic == 1 ? false: true">
                 <b-col md="3" sm="12">    
                     <b-form-group label="CNAE:" label-for="groupitem-cnae">
                        <b-form-input 
                            id="groupitem-cnae" 
                            type="text"
                            v-model="groupitem.cnae"
                            v-on:keyup.alt.83="save" 
                            v-on:keyup.alt.90="[reset(),focusSearch()]"
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código CNAE..." />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="groupitem.complements_item" 
                                true-value="1" 
                                false-value="0" 
                                v-on:keyup.alt.90="[reset(),focusSearch()]"
                                v-on:keyup.alt.83="save"
                                type="checkbox" 
                                id="groupitem-complements_item"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="groupitem-complements_item">
                                Descrição do Grupo Complementa descrição do Item?
                            </label>
                        </div>
                    </div>
                </b-col>  
                 <b-col md="3" sm="12">
                        <b-form-group label="Qtde. Mínima (Padrão):" label-for="groupitem-minimum_quantity_standard">
                        <b-form-input id="groupitem-minimum_quantity_standard" 
                            v-model="groupitem.minimum_quantity_standard" 
                            type="number"
                            v-on:keyup.alt.83="save"
                            v-on:keyup.alt.90="[reset(),focusSearch()]"
                            size="sm"
                            step="0.02"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group label="Qtde. Máxima (Padrão):" label-for="groupitem-maximum_quantity_standard">
                        <b-form-input id="groupitem-maximum_quantity_standard" 
                            v-model="groupitem.maximum_quantity_standard" 
                            type="number"
                            v-on:keyup.alt.83="save"
                            v-on:keyup.alt.90="[reset(),focusSearch()]"
                            size="sm"
                            step="0.02"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
            </b-row>
            <hr>
         </b-form>

              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="dark" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="dark"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadGroupitems(),toggleBusy(),showTable = !showTable]" 
                         variant="dark" >
                    </b-button>
                </b-col>
            </b-row>
              <hr>
                <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            v-on:keyup.alt.enter="alterModo" 
                            type="text" 
                            size="sm" 
                            title="Atalho para Inserir (ALT+ENTER => ALT+I)"
                            ref="inputsearch"  
                            icon="search" 
                            v-model="search" 
                            placeholder="Informe o nome do Grupo do Item" 
                            class="form-control">
                    </div>
                </div>
     
         <transition  name="slide" type="animation" appear>       
         <b-table 
              :busy="isBusy"  
            class="table-responsive" 
            :per-page="perPage" 
            :current-page="currentPage" 
            v-show="showTable" 
            hover key="slide" 
            head-variant="light"  
            :items="filteredList" 
            :fields="fields">
             <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button 
                         title = "Detalhe do registro" 
                         size="sm" 
                         variant="light" 
                         @click="loadGroupitem(data.item, 'read')" 
                         class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Editar registro" 
                        size="sm" 
                        variant="light" 
                        @click="loadGroupitem(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button  
                        title = "Excluir registro" 
                        size="sm" 
                        variant="light" 
                        @click="loadGroupitem(data.item, 'remove')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>  
                <template v-slot:cell(accesses)="data">
                    <b-button  
                        title = "Acesso aos Cadastro de Itens" 
                        v-show="data.item.synthetic == 0"  
                        size="sm" variant="light" 
                        @click="actionItem(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-external-link"></i>
                    </b-button>
                 </template>  
         </b-table>    
         </transition>
        <transition  name="slide" type="animation" appear>  
            <b-pagination
            v-show="showTable"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            size="sm"
            aria-controls="my-table"
            ></b-pagination>
         </transition>    
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'GroupItem',
    components: {PageTitle},
    data: function() {
        return {
            mode: 'insert',
            search: '',
            searchFocus: null,
            groupitem: {},
            groupitems: [],
            showTable: false,
            internal_code: null,
             isBusy: false,
            perPage: 5,
            currentPage: 1,
            fields: [
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'internal_code_group_item', label: 'Código Interno', sortable: false, variant: 'secondary' },
                { key: 'synthetic', label: 'Sintético', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },
                { key: 'item_sale', label: 'Grupo de Venda', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },    
                { key: 'item_purchase', label: 'Grupo de Compra', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },     
                { key: 'item_service', label: 'Grupo de Serviço', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },         
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações', variant: 'light' },
                { key: 'accesses', label: 'Acessos', variant: 'secondary' }
            ]
        }
    },
     computed: {
        filteredList() {
        return this.groupitems.filter(groupitem => {
            return (
                groupitem.name.toLowerCase().includes(this.search.toLowerCase()) ||
                 groupitem.internal_code_group_item.toLowerCase().includes(this.search.toLowerCase())
                )
            })
        },
        icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        }, 
        rows() {
            return this.groupitems.length
        },
    },
    methods: {
       async loadGroupitems() {
            const url = `${baseApiUrl}/groupitems`
            await axios.get(url).then(res => {
                this.groupitems = res.data
                this.isBusy = false
            })
        },
       reset() {
            this.mode = 'insert'
            this.loadGroupitems()
        },
         toggleBusy() {
                this.isBusy = !this.isBusy
        },
        alterModo() {
            this.mode = 'save'
            this.groupitem = {}
            },
        actionItem(groupitem) {                   
            this.$router.push({
                    name: 'itemSearch',    
                    params: {id: groupitem.id}
                })
        },   
       async save() {
            const method = this.groupitem.id ? 'put' : 'post'
            const id = this.groupitem.id ? `/${this.groupitem.id}` : ''
            await axios[method](`${baseApiUrl}/groupitems${id}`, this.groupitem)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
       async remove() {
            const id = this.groupitem.id
            await axios.delete(`${baseApiUrl}/groupitems/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.reset()
                })
                .catch(showError)
        },
        loadGroupitem(groupitem, mode = 'save') {
            this.mode = mode
            this.groupitem = { ...groupitem }

        },
    },
   async mounted() {
        this.showTable = true
        this.loadGroupitems()
      
    }
}
</script>

<style>


    .groupitem-admin input,label,form{
        font-size: 0.7rem;
    }
    .groupitem-admin button{
        font-size: 0.7rem;
    }
     .groupitem-admin select{
        font-size: 0.7rem;
    }

    .groupitem-admin table{
        font-size: 0.7rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
